module.exports = __webpack_public_path__ + "img/logo_light.0d19f9b4.png";